import { useContext } from 'react';
import { AdminPermissionsContext } from '../context/AdminPermissionsContext';
import { useSecurity } from '../context/SecurityContext';
import {
  canAccessAdminRoute,
  getAdminPermissions,
  getAssignableAdminRoles,
  getAdminRoleMeta,
  normalizeAdminRoleCode,
} from '../utils/adminPermissions';

/** Fuera del layout admin (p. ej. tests): calcula permisos desde SecurityContext. */
function useAdminPermissionsFallback() {
  const { adminUser, isInitializing } = useSecurity();
  const roleCode = normalizeAdminRoleCode(adminUser?.role);
  const perms = getAdminPermissions(roleCode);
  return {
    ...perms,
    roleReady: !isInitializing && !!adminUser,
    getRoleMeta: getAdminRoleMeta,
    getAssignableRoles: () => getAssignableAdminRoles(roleCode),
    canAccessRoute: (path) => canAccessAdminRoute(roleCode, path),
    guardWrite: (message = 'Tu rol no tiene permiso para modificar datos.') => {
      if (perms.canWrite) return true;
      return { blocked: true, message };
    },
  };
}

export function useAdminPermissions() {
  const ctx = useContext(AdminPermissionsContext);
  if (ctx) return ctx;
  return useAdminPermissionsFallback();
}
